import React from 'react';
import NavCard from '../../components/NavCard';
import {
  reports,
  precisionspray,
  shop,
  dashboard,
  support,
  savings
} from '../../../images';
import styles from './Home.module.css';
import { useSelector } from 'react-redux';

export default function Home() {
  const isManager = useSelector((state) => state.app.isManager);
  const isAdmin = useSelector((state) => state.app.isAdmin);
  const [userType, setUserType] = React.useState('');
  const user = useSelector((state) => state.app.user);
  const handleExternalLinkClick = (externalLink) => {
    setTimeout(() => {
      window.open(externalLink, '_blank');
    }, 250);
  };

  const blockedRoute = !isManager && !isAdmin;

  return (
    <div className={styles.container}>
      <div className={styles.gridContainer}>
        <div>
          <NavCard
            title="Dashboard"
            actionText="Get Started"
            icon={dashboard}
            link="/dashboard"
          />
        </div>
        <div>
          <NavCard
            title="Sprayers"
            actionText="Get Started"
            icon={precisionspray}
            link="/precision-spray"
          />
        </div>
        <div>
          <NavCard
            title="Reports"
            actionText="Get Started"
            icon={reports}
            link="/reports"
            disabled={blockedRoute}
          />
        </div>
        <div>
          <NavCard
            title="Savings"
            actionText="Get Started"
            icon={savings}
            link="/savings"
          />
        </div>
        <div style={{ cursor: 'pointer' }}>
          <NavCard
            title="Tech Support"
            actionText="Get Started"
            icon={support}
            link="/tech-support"
          />
        </div>
        <div style={{ cursor: 'pointer' }} 
          onClick={() => handleExternalLinkClick('https://www.agtechlogic.shop')}>
          <NavCard
            title="Shop"
            actionText="Visit Shop"
            icon={shop}
          />
        </div>

      </div>
    </div>
  );
}
